import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class ModifyOrder extends BaseUseCase {
    constructor(repo) {
        super();
        this.repo = repo;
    }
    async fetchResult(req) {
        return await this.repo.modifyOrder(req);
    }
}
export default ModifyOrder;
